export default {
  namespaced: true,
  state: {
    relationship: [
      { name: '未選択', value: 0 },
      { name: '母', value: 1 },
      { name: '父', value: 2 },
      { name: '祖母', value: 3 },
      { name: '祖父', value: 4 },
      { name: '本人', value: 5 },
      { name: '伯母', value: 6 },
      { name: '伯父', value: 7 }
    ],

    guidance_type: [
      { name: '未選択', value: 0 },
      { name: '1人指導', value: 1 },
      { name: '2人同時指導', value: 2 },
      { name: '3人同時指導', value: 3 }
    ],

    unit: [
      { name: '未選択', value: 0 },
      { name: '1件口', value: 1 },
      { name: '2件口', value: 2 },
      { name: '3件口', value: 3 }
    ],

    preferred_contact: [
      { name: '未選択', value: 0 },
      { name: '自宅', value: 1 },
      { name: '携帯', value: 2 },
      { name: '勤務先', value: 3 },
      { name: 'その他', value: 4 }
    ]
  },
  mutations: {},
  actions: {},
  getters: {
    relationship (state) { return state.relationship },
    guidance_type (state) { return state.guidance_type },
    unit (state) { return state.unit },
    preferred_contact (state) { return state.preferred_contact }
  }
}



// WEBPACK FOOTER //
// ./src/store/families.js